import { isEmpty } from './is-empty.js';

export function isNotEmpty<T>(value: T[]): value is NotEmptyArray<T> {
  return !isEmpty(value);
}
